import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { ZefDialogModule } from '@zerops/zef/dialog';
import { ZefProgressErrorModule } from '@zerops/zef/progress-error';
import { AddonActivationDialogContainer } from './addon-activation-dialog.container';
import { AddonActivationDialogTranslationsModule } from './addon-activation-dialog.translations';

@NgModule({
  declarations: [ AddonActivationDialogContainer ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    ZefDialogModule,
    AddonActivationDialogTranslationsModule,
    ZefProgressErrorModule
  ],
  exports: [ AddonActivationDialogContainer ]
})
export class AddonActivationDialogModule {

}
